import React from 'react';

import { useIntl } from 'react-intl';

import { CancellationPolicyText, Title, Wrapper } from './cancellation-policy.styled';

export const DeliveryCancellationPolicy = () => {
  const { formatMessage } = useIntl();

  return (
    <Wrapper>
      <Title>{formatMessage({ id: 'cancellationPolicyTitle' })}</Title>
      <CancellationPolicyText>{formatMessage({ id: 'cancellationPolicy' })}</CancellationPolicyText>
    </Wrapper>
  );
};
